import { useTrans } from "@/i18n"

import { MangopayHostedKyc } from "./_components/MangopayHostedKyc"
import { InvestorIdentityForm } from "./_components/InvestorIdentityForm"
import { BusinessVerificationForm } from "./_components/BusinessVerificationForm"

export const InvestorIdentity = () => {
	const t = useTrans("investor")

	return (
		<>
			<title>
				{t("common:web.title", {
					page: t("investor:identity.title"),
				})}
			</title>

			{/* Each child decides for itself whether to render based on the
			    user's hosted-KYC flag and identity type. The MangopayGate
			    inside each blocks interaction while payment permissions are
			    missing. */}
			<MangopayHostedKyc />
			<BusinessVerificationForm />
			<InvestorIdentityForm />
		</>
	)
}
